import { render, staticRenderFns } from "./form-password.vue?vue&type=template&id=cccce58c&scoped=true&"
import script from "./form-password.vue?vue&type=script&lang=js&"
export * from "./form-password.vue?vue&type=script&lang=js&"
import style0 from "./form-password.vue?vue&type=style&index=0&id=cccce58c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cccce58c",
  null
  
)

export default component.exports